import { types } from './actions';

const initialState = {
  areLeadTimeSettingsSaving: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_LEAD_TIME_UNIT_REQUEST:
      return {
        ...state,
        areLeadTimeSettingsSaving: true,
      };
    case types.UPDATE_LEAD_TIME_UNIT_SUCCESS:
    case types.UPDATE_LEAD_TIME_UNIT_ERROR:
      return {
        ...state,
        areLeadTimeSettingsSaving: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.digitalQuote.leadTimes;

export const areLeadTimeSettingsSaving = (state) =>
  getScope(state).areLeadTimeSettingsSaving;
